import { PERF_DEBUG } from '../core/constants';

export function perfStart(label, meta) {
    if (!PERF_DEBUG) return null;

    return {
        label: label,
        meta: meta || {},
        startedAt: window.performance && performance.now ? performance.now() : Date.now()
    };
}

export function perfEnd(token, meta) {
    if (!token || !window.console || !console.info) return;

    var endedAt = window.performance && performance.now ? performance.now() : Date.now();
    console.info('[rcn-newmobilemap perf]', token.label, Object.assign({}, token.meta, meta || {}, {
        durationMs: Math.round((endedAt - token.startedAt) * 10) / 10
    }));
}